import 'whatwg-fetch';

import React from 'react';
import PropTypes from 'prop-types';

import { iterUnpack } from '../../services/APIClient';
import SegmentClient from '../../services/SegmentClient';
import Alert from '../Alert';
import { ANALYTICS_NAME } from './Constants';

const segment = new SegmentClient();

export default class BrandDetailArticles extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  UNSAFE_componentWillMount() {
    const props = iterUnpack(JSON.parse(window.props));
    const brand = props.allBrands[0];
    this.setState({
      articles: brand.articles || [],
    });
  }

  defaultState = () => ({
    articles: [],
  });

  render() {
    const { articles } = this.state;

    const emptyMessage = this.props.emptyMessage || 'No Content Available';

    return (
      <div className="row">
        <h3 className="columns small-12 pb-base fs-m fw-medium">
          <i className="material-icons">import_contacts</i>
          {' '}
          Articles
        </h3>
        <div className="columns small-12">
          {articles && articles.length
            ? articles.map(({ article: { url, title } }) => (
              <div className="pl-0 pb-s ellipsis" key={title}>
                <a
                  href={`${url}`}
                  className="black ellipsis"
                  onClick={() => segment.track(ANALYTICS_NAME.BRAND_PROFILE_ARTICLE_CLICKED, {
                    link_url: url,
                  })}
                  target="_blank"
                  rel="noreferrer"
                >
                  {title}
                </a>
              </div>
            ))
            : (
              <Alert type="secondary">
                {emptyMessage}
              </Alert>
            )}
        </div>
      </div>
    );
  }
}

BrandDetailArticles.propTypes = {
  emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

BrandDetailArticles.defaultProps = {
  emptyMessage: null,
};
